<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('groupTracking.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('groupTracking.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex ts-items-center ts-space-x-3">
            <ts-input
              v-tooltip="$t('groupTracking.search')"
              v-model="search"
              :placeholder="$t('groupTracking.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.group_name }}</td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('add')"
                class="text-primary"
                @click.prevent="addUser(record)"
              >
                <i class="fas fa-user-plus"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('Map')"
                class="ts-text-gray-800"
                @click.prevent="onViewMap(record)"
              >
                <i class="fas fa-map-marked-alt"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>

      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="
          isUpdate
            ? $t('groupTracking.updateGroup')
            : $t('groupTracking.createNewGroup')
        "
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>

      <a-modal
        v-if="showAddUser"
        v-model="showAddUser"
        :title="$t('groupTracking.addUser')"
        centered
        @cancel="clearAddUser"
        :zIndex="1020"
        :footer="null"
        width="50%"
      >
        <add-user-form @cancel="clearAddUser" @fetchData="fetchData" :record="addGroup" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FromAction from './form.vue'
import AddUserForm from './addUser.vue'
import { debounce, isEmpty } from 'lodash'

export default {
  name: 'groupTracking',
  components: {
    FromAction,
		AddUserForm
  },
  data() {
    return {
      loading: false,
      showForm: false,
      showAddUser: false,
      addGroup: {}
    }
  },
  computed: {
    ...mapState('sale/groupTracking', ['resources', 'pagination', 'edit_data']),
    search: {
      get() {
        return this.$store.state.sale.groupTracking.search
      },
      set(newValue) {
        this.$store.commit('sale/groupTracking/SET_SEARCH', newValue)
        this.$store.commit('sale/groupTracking/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('groupTracking.groupName') },
        { name: this.$t('actions'), style: 'text-align:center; width:200px' }
      ]
    },
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('sale/groupTracking/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('sale/groupTracking/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('sale/groupTracking/destroy', record.id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    edit(record) {
      this.$store.commit('sale/groupTracking/SET_EDIT_DATA', record)
      this.showForm = true
    },
    addUser(record) {
      this.addGroup = record
      this.showAddUser = true
    },
    clearAddUser() {
      this.addGroup = {}
      this.showAddUser = false
    },
    onViewMap(record) {
      this.$router.push({
        name: 'group-tracking-map-view',
        query: {
          id: record.id
        }
      })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
